const CHARGE = 'charge';
const COMBAT = 'combat';
const SHOOTING = 'shooting';

export {CHARGE, COMBAT, SHOOTING};